import React, { useEffect, useState } from 'react';
import { Button, FormGroup, Label, Row, Col, Input, Table, CardFooter, Card } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from '../../layouts/breadcrumbs/BreadCrumbs';
import ComponentCard from '../ComponentCard';
import useHttp from '../../hooks/useHttp';
import useAlert from '../../hooks/useAlert';
import AutoComplete from '../common/AutoComplete';
import Loader from '../../layouts/loader/Loader';

const PartnerUserCreate = () => {
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [assignedZones, setAssignedZones] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    name: '',
    phone: '',
    email: '',
    status: 'Active',
  });

  const { error, isLoading, sendRequest } = useHttp();
  const { alert, successAlert, errorAlert } = useAlert();

  useEffect(() => {
    if (error) errorAlert(error);
  }, [error, errorAlert]);

  const successAction = (data) => {
    successAlert(`Successfully ${data.username} created`, () => navigate("../list"));
  }


  useEffect(() => {
    sendRequest(
      {
        method: 'GET',
        url: `${process.env.REACT_APP_IBILL_GATEWAY}/platform/api/v1/zones-for-auto-complete`,
        headers: { Accept: 'application/json' },
      },
      (data) => setZones(data || [])
    );
  }, [sendRequest]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAssignZone = () => {
    if (selectedZone && !assignedZones.some((zone) => zone.code === selectedZone.code)) {
      setAssignedZones((prev) => [...prev, selectedZone]);
      setSelectedZone(null);
    }
  };

  const handleRemoveZone = (zoneCode) => {
    setAssignedZones((prev) => prev.filter((zone) => zone.code !== zoneCode));
  };

  const submitAction = () => {

    if(!formData.username || !formData.name || !formData.phone || !formData.email || !formData.status ) {
      errorAlert('Please fill all mandatory fields.');
      return;
    }
    if (assignedZones.length === 0) {
      errorAlert('Please assign at least one zone.');
      return;
    }

    const payload = {
      ...formData,
      'accessible-zones': assignedZones.map((zone) => zone.code),
    };


    const requestConfigData = {
      url: `${process.env.REACT_APP_IBILL_GATEWAY}/hub/api/v1/partner-user/register`,
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: payload,
    };
    sendRequest(requestConfigData, successAction)
  };

  const cancelAction = () => {
    setFormData({ username: '', name: '', phone: '', email: '', status: '' });
    setAssignedZones([]);
  };

  return (
    <div>
      {alert}
      <BreadCrumbs />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <ComponentCard title="Create Partner User">
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="name">Name <span style={{ color: 'red' }}>*</span></Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="phone">Phone <span style={{ color: 'red' }}>*</span></Label>
                  <Input
                    type="text"
                    name="phone"
                    id="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="email">Email <span style={{ color: 'red' }}>*</span></Label>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="status">Status <span style={{ color: 'red' }}>*</span></Label>
                  <Input
                    type="select"
                    name="status"
                    id="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="username">Username <span style={{ color: 'red' }}>*</span></Label>
                  <Input
                    type="text"
                    name="username"
                    id="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
          </ComponentCard>
          <ComponentCard title="Zone Access">
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="zoneSearch">Search Zone</Label>
                  <AutoComplete
                    searchItems={zones}
                    handleOnSelect={(item) => setSelectedZone(item)}
                    handleOnClear={() => setSelectedZone(null)}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                <Button
                  color="primary"
                  className="mt-4"
                  onClick={handleAssignZone}
                  disabled={!selectedZone}
                >
                  Assign
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h5>Assigned Zones <span style={{ color: 'red' }}>*</span></h5>
                <Table bordered>
                <thead>
                  <tr>
                    <th>Zone Code</th>
                    <th>Zone Name</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  {assignedZones.map((zone) => (
                    <tr key={zone.code}>
                      <td>{zone.code}</td>
                      <td>{zone.name}</td>
                      <td>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleRemoveZone(zone.code)}
                        >
                          Remove
                        </Button>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </ComponentCard>
          <Card>
            <CardFooter>
              <Row>
                <div className="col-md-2">
                  <Button
                    className="btn col-12 btn-block btn-danger"
                    onClick={cancelAction}
                  >
                    Cancel
                  </Button>
                </div>
                <div className="col-md-8" />
                <div className="col-md-2">
                  <Button className="btn col-12 btn-block btn-success"
                          onClick={submitAction}>Submit</Button>
                </div>
              </Row>
            </CardFooter>
          </Card>
        </>
      )}
    </div>
  );
};

export default PartnerUserCreate;